module.exports = __webpack_public_path__ + "fonts/abduction2002.97f3f577.ttf";